import { ContextMenu, SVG, Button } from "shared";
import { SVG_ENUM } from "enums";
import { SuccessorType } from "types/SuccessorTypes";

const items = ({ setShowDelete }: { setShowDelete?: any }) => {
  return (document: any) => {
    const actions = [];
    actions.push({
      name: "Usuń",
      action: () => setShowDelete && setShowDelete(document.uuid),
      svg: SVG_ENUM.TRASH,
    });

    return actions;
  };
};

export const mobileColumns = ({
  setShowDelete,
  setFinalizePayment,
}: {
  setShowDelete?: any;
  setFinalizePayment: (successor: SuccessorType) => void;
}) => [
  {
    render: (value: any) => {
      return <div>{<p>{value.fullName}</p>}</div>;
    },
  },
  {
    key: "isPaid",
    dataIndex: "isPaid",
    render: (value: any, record: any) => (
      <>
        {!record.isPaid && (
          <Button
            label="Dokończ płatność"
            onClick={() => setFinalizePayment(record)}
            className="button--wide"
            size="small"
            styleType="strokeBlack"
          />
        )}
      </>
    ),
  },
  {
    width: 20,
    render: (item: any) => (
      <ContextMenu
        data={item}
        items={items({
          setShowDelete,
        })(item)}
      >
        <SVG type={SVG_ENUM.DOTS} />
      </ContextMenu>
    ),
  },
];

export const desktopColumns = ({
  setShowDelete,
  setFinalizePayment,
}: {
  setShowDelete: any;
  setFinalizePayment: (successor: SuccessorType) => void;
}) => {
  const columns = [
    {
      title: "Imię i nazwisko",
      width: "250px",
      render: (value: any) => {
        return (
          <div>
            <p>{value.fullName}</p>
          </div>
        );
      },
    },
    {
      title: "Numer PESEL",
      key: "nationalId",
      dataIndex: "nationalId",
    },
    {
      title: "Telefon",
      key: "phone",
      dataIndex: "phone",
    },
    {
      title: "E-mail",
      key: "email",
      dataIndex: "email",
    },
    {
      title: "Adres",
      key: "address",
      dataIndex: "address",
      render: (value: any, record: any) =>
        `${record.address}, ${record.postalCode} ${record.city}`,
    },
    {
      key: "isPaid",
      dataIndex: "isPaid",
      render: (value: any, record: any) => (
        <>
          {!record.isPaid && (
            <Button
              label="Dokończ płatność"
              onClick={() => setFinalizePayment(record)}
              className="button--wide"
              size="small"
              styleType="strokeBlack"
            />
          )}
        </>
      ),
    },
    {
      width: 20,
      render: (item: any) => (
        <ContextMenu
          data={item}
          items={items({
            setShowDelete,
          })(item)}
        >
          <SVG type={SVG_ENUM.DOTS} />
        </ContextMenu>
      ),
    },
  ];

  return columns;
};
